module.exports = __webpack_public_path__ + "img/GreekTechTriremeS_ua.604ddc99.webp";